import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class BatchBreadcrumbLinks extends Component {
  static propTypes = {
    batchId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired,
    batchDisplayId: PropTypes.string.isRequired,
    batchFileName: PropTypes.string
  };

  static defaultProps = {
    batchFileName: null
  };

  getBatchFilePart() {
    const {
      batchId,
      batchDisplayId,
      batchFileName
    } = this.props;

    if (batchFileName) {
      return (
        <React.Fragment>
          <span className="h3">&gt;</span>
          <Link to={ `/batches/${ batchId }` } className="btn btn-link" title={ batchDisplayId }>{ batchDisplayId }</Link>
          <span className="h3">&gt;</span>
          <span className="btn btn-link">{ batchFileName }</span>
        </React.Fragment>);
    }

    return (
      <React.Fragment>
        <span className="h3">&gt;</span>
        <span className="btn btn-link">{ batchDisplayId }</span>
      </React.Fragment>);
  }

  render() {
    const {
      batchDisplayId
    } = this.props;

    return batchDisplayId && (
      <div className="breadcrumbs inline">
        | <Link to="/batches" className="btn btn-link" content="Uploaded Batches">Uploaded Batches</Link>
        { this.getBatchFilePart() }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const BatchBreadcrumbs = connect(
  null,
  mapDispatchToProps
)(BatchBreadcrumbLinks);

export default BatchBreadcrumbs;
